import { render, staticRenderFns } from "./person-picker.vue?vue&type=template&id=419e355c&"
import script from "./person-picker.vue?vue&type=script&lang=js&"
export * from "./person-picker.vue?vue&type=script&lang=js&"
import style0 from "./person-picker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports